<template>
  <div>
    <el-dialog width="800px" :visible.sync="isShow" title="人员信息" :close-on-click-modal="false"
      :close-on-press-escape="false" class="addStaff__dialog default-dialog">
      <div class="addStaff__body" v-loading="loading">
        <el-form :model="staffForm" :rules="rules" ref="staffForm" label-width="100px" label-position="top"
          class="addStaff__body__form">
          <div v-for="(item, index) in formRenderList" :key="index">
            <div v-if="!item.title">
              <el-form-item v-for="subItem in item.children" :key="subItem.prop" :label="subItem.label"
                :prop="subItem.prop">
                <el-radio-group v-model="staffForm[subItem.prop]" v-if="subItem.type === 'radio'"
                  :disabled="subItem.disabled">
                  <el-radio v-for="ra_item in subItem.options" :key="ra_item.value" :label="ra_item.value">{{
                    ra_item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-else>
              <div class="addStaff__body__form__title">{{ item.title }}</div>
              <div v-for="(subItem, index) in item.children" :key="index">
                <div class="addStaff__body__form__rows" v-if="subItem.isRow">
                  <el-form-item v-for="subItem_c in subItem.children" :key="subItem_c.prop" :label="subItem_c.label"
                    :prop="subItem_c.prop" :class="subItem.isTail ? 'rows__item--tail' : ''">
                    <el-cascader v-if="subItem_c.type === 'cascader'" :options="provinceList" :props="lazyLoad"
                      clearable class="rows__item" v-model="staffForm[subItem_c.prop]" :disabled="subItem_c.disabled">
                    </el-cascader>
                    <el-select v-model="staffForm[subItem_c.prop]" :placeholder="`请选择${subItem_c.label}`"
                      class="rows__item" v-if="subItem_c.type === 'select'" clearable
                      :disabled="((subItem_c.prop == 'gender' || subItem_c.prop == 'nationality') && disabledGenderAndBirthday) || subItem_c.disabled"
                      filterable>
                      <el-option v-for="se_item in subItem_c.options" :key="se_item.id || se_item.value"
                        :label="se_item.label" :value="se_item.value"></el-option>
                    </el-select>
                    <el-input v-model="staffForm[subItem_c.prop]" class="rows__item"
                      :placeholder="`请输入${subItem_c.label} ${subItem_c.disabled ? '禁用' : '开启'}`"
                      v-if="subItem_c.type === 'input'"
                      :disabled="subItem_c.disabled || (subItem_c.prop == 'nationality' && disabledGenderAndBirthday)"></el-input>
                    <el-date-picker v-model="staffForm[subItem_c.prop]" type="date" value-format="yyyy-MM-dd"
                      class="rows__item" :placeholder="`请选择${subItem_c.label}`" v-if="subItem_c.type === 'date'"
                      :disabled="subItem_c.disabled || (subItem_c.prop == 'birthday' && disabledGenderAndBirthday)"></el-date-picker>
                    <el-checkbox-group v-model="staffForm[subItem_c.prop]" v-if="subItem_c.type === 'checkbox'"
                      @change="changeRules(staffForm[subItem_c.prop])" style="margin-bottom:10px;"
                      :disabled="subItem_c.disabled">
                      <el-checkbox v-for="cb in subItem_c.options" :label="cb.label" :key="cb.value">{{ cb.label
                        }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="footer acc_flex" slot="footer" v-if="!isReadonly">
        <el-button size="small" @click="isShow = false">取消</el-button>
        <el-button size="small" class="submit" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { provinceList } from '@/assets/ChinaArea/province.js'
import { formRenderList } from '../index.js'
import { mapState, } from "vuex"
import { saveStaff, findJsonAreaList, findWorkCode } from '@/api'
export default {
  data() {
    return {
      disabledGenderAndBirthday: false,
      areaList: [],
      isShow: false,
      lazyLoad: {
        value: 'name',
        checkStrictly: true,
        label: 'name',
        lazy: true,
        lazyLoad: this.lazyLoadFn
      },
      loading: false,
      isReadonly: false,
      provinceList,
      formRenderList: [],
      staffForm: {
        status: '',
        cardType: '',
        cardNo: '',
        name: '',
        nationality: '',
        gender: '',
        education: '',
        birthday: '',
        identifyNo: '',
        situation: [],
        disabilityType: '',
        disabilityNo: '',
        heroNo: '',
        newRemark: "",
        hireType: '',
        entryDate: '',
        dimissionDate: '',
        payfiveOne: '',
        currentJobInfo: '',
        workCode: '',
        jobTitle: '',
        phone: '',
        email: '',
        address: [],
        address_input: '',
        contactAddress: [],
        contactAddress_input: '',
        bankProvince: '',
        bankAccount: '',
        homeAddress: [],
        homeAddress_input: '',
        invest: '',
        investPer: '',
        bankName: '',
      },
      nowRow: {},
      rules: {
        investPer: [{ trigger: 'blur', validator: this.validateFn },],
        cardType: [
          { required: true, trigger: 'change', validator: this.validateFn },
        ],
        cardNo: [
          { required: true, trigger: 'blur', validator: this.validateFn },
        ],
        phone: [
          { required: true, trigger: 'blur', validator: this.validateFn },
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' },
        ],
        birthday: [
          { required: true, message: '请选择出生日期', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
  methods: {
    getWorkCode() {
      findWorkCode().then(res => {
        if (res.data.code == 1) {
          if (res.data.msg) {
            const ret = res.data.msg.split(',')
            if (ret.length) {
              this.staffForm.workCode = ret[0]
              // this.staffForm.identifyNo = ret[1]
            }
          }
        }
      })
    },
    getArea() {
      const areaList = this.accountInfo.areaList
      if (areaList && areaList.length) {
        this.areaList = areaList
        this.renderAllChooseAdress()
      } else {
        findJsonAreaList().then(res => {
          this.areaList = res.data.data
          this.renderAllChooseAdress()
          this.$store.commit('SET_AREA_LIST', res.data.data)
        })
      }
    },
    changeRules(value) {
      if (value.includes('残疾')) {
        this.$set(this.rules, 'disabilityType', [{ required: true, message: '选择残疾类型', trigger: 'change' },])
        this.$set(this.rules, 'disabilityNo', [{ required: true, message: '请输入残疾证号', trigger: 'blur' },])
        console.log(this.rules)
      } else {
        this.$set(this.rules, 'disabilityType', [])
        this.$set(this.rules, 'disabilityNo', [])
        console.log(this.rules)
      }
      this.$refs.staffForm.clearValidate()
    },
    renderAllChooseAdress() {
      let renderKeyList = ['address', 'contactAddress', 'homeAddress']
      this.areaList.forEach(x => {
        for (let i = 0; i < renderKeyList.length; i++) {
          let name = ""
          if (this.staffForm[renderKeyList[i]] && this.staffForm[renderKeyList[i]].length) {
            name = this.staffForm[renderKeyList[i]][0]
          }
          if (name == x.name) {
            let nodes = JSON.parse(x.content).children
            let nowRenderObj = this.provinceList.find(city => city.name == name)
            if (nowRenderObj) {
              nowRenderObj.children = nodes
            }
            this.provinceList = JSON.parse(JSON.stringify(this.provinceList))
          }
        }
      })
    },
    openTask(row, isReadonly) {
      this.isShow = true
      this.nowRow = row || {}
      if (row && row.id) {
        console.log('row', row);
        for (let key in row) {
          if (key == "entryDate" || key == "birthday" || key == "dimissionDate") {
            this.staffForm[key] = this.$formart(this.nowRow[key], 'yyyy-MM-dd')
          } else if (key == "address" || key == "contactAddress" || key == "homeAddress") {
            if(row[key]) {
              let address = row[key].split(',')
               // 取最后一个地址
              let key_input = `${key}_input`
              // 需要渲染所选的所有地址
              this.staffForm[key] = address.slice(0, address.length - 1)
              this.staffForm[key_input] = address[address.length - 1]
            }
          } else if (key == "disability" || key == "hero" || key == "alone") {
            let pushList = []
            if (row.disability) {
              pushList.push('残疾')
            }
            if (row.hero) {
              pushList.push('烈属')
            }
            if (row.alone) {
              pushList.push('孤老')
            }
            this.staffForm.situation = pushList
          } else {
            this.staffForm[key] = this.nowRow[key]
          }

        }
        if(this.staffForm.cardType == 1) {
            // 禁用生日和性别
            this.disabledGenderAndBirthday = true
            this.staffForm.nationality = this.staffForm.nationality|| "中国"
          }
        if (isReadonly) {
          let _formRenderList = JSON.parse(JSON.stringify(formRenderList))
          for (let i = 0; i < _formRenderList.length; i++) {
            for (let j = 0; j < _formRenderList[i].children.length; j++) {
              let children = _formRenderList[i].children[j]
              if (children && children.children) {
                for (let k = 0; k < children.children.length; k++) {
                  children.children[k].disabled = true
                }
              } else {
                children.disabled = true
              }
            }
          }
          this.formRenderList = _formRenderList
          this.isReadonly = true
          return
        }
      } else {
        this.staffForm = {
          status: '',
          cardType: '',
          cardNo: '',
          name: '',
          nationality: '',
          gender: '',
          education: '',
          birthday: '',
          identifyNo: '',
          situation: [],
          disabilityType: '',
          disabilityNo: '',
          heroNo: '',
          hireType: '',
          entryDate: '',
          dimissionDate: '',
          payfiveOne: '',
          currentJobInfo: '',
          workCode: '',
          jobTitle: '',
          phone: '',
          email: '',
          address: [],
          address_input: '',
          contactAddress: [],
          contactAddress_input: '',
          bankProvince: '',
          bankAccount: '',
          homeAddress: [],
          homeAddress_input: '',
          invest: '',
          investPer: '',
          bankName: '',
        }
      }
      this.formRenderList = formRenderList
      this.isReadonly = false
      this.getWorkCode()
      this.getArea()
    },
    // 格式化出生日期，返回标准日期格式 YYYY-MM-DD
    formatDate(birthDateStr) {
      const year = birthDateStr.slice(0, 4);
      const month = birthDateStr.slice(4, 6);
      const day = birthDateStr.slice(6, 8);
      return `${year}-${month}-${day}`;
    },
    //根据身份证号识别性别
    getGenderByIdNumber(idNumber) {
      // 获取第17位数字（即性别标识位）
      const genderDigit = parseInt(idNumber.charAt(16));  // 第17位（从0开始）

      // 根据第17位的数字判断性别
      if (genderDigit % 2 === 0) {
        return 2;
      } else {
        return 1;
      }
    },
    validateFn(rule, value, callback) {
      const cardNo = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dxX]$/; //身份证校验
      const pattern = /^1[3456789]\d{9}$/;  //手机号校验
      if (rule.field == 'cardNo') {
        if (!(cardNo.test(value)) && this.staffForm.cardType == 1) {
          callback(new Error('证件号码不正确'))
        } else {
          if (this.staffForm.cardType == 1) { //选择居民身份证 自动写入性别和出生日期
            this.staffForm.gender = this.getGenderByIdNumber(value)
            this.staffForm.identifyNo = this.staffForm.cardNo
            this.birthday
            // 提取出生日期部分（第7-14位）
            const birthDateStr = value.slice(6, 14);  // 18位身份证号，出生日期在第7至14位
            this.staffForm.birthday = this.formatDate(birthDateStr)
          }else {
            this.staffForm.identifyNo = ""
          }
          callback()
        }
      }
      if (rule.field == 'cardType') {
        if (!value) {
          callback(new Error('请选择证件类型'))
        } else {
          if (this.staffForm.cardType == 1 && this.staffForm.cardNo) {
            this.staffForm.gender = this.getGenderByIdNumber(this.staffForm.cardNo)
            const birthDateStr = this.staffForm.cardNo.slice(6, 14);
            this.staffForm.birthday = this.formatDate(birthDateStr)
            this.staffForm.identifyNo = this.staffForm.cardNo
          }
          if (this.staffForm.cardType == 1) {
            // 禁用生日和性别
            this.disabledGenderAndBirthday = true
            this.staffForm.nationality = this.staffForm.nationality || "中国"
          } else {
            this.disabledGenderAndBirthday = false
            this.staffForm.identifyNo = ""
            this.staffForm.nationality = ""
          }
          callback()
        }
      }
      if (rule.field == 'phone') {
        if (!value) {
          callback(new Error('请输入手机号'))
        } else {
          if (!(pattern.test(value))) {
            callback(new Error('手机号不正确'))
          } else {
            callback()
          }
        }
      }
      if (rule.field == 'investPer') {
        const reg = /^(\d{1,2}(?:\.\d{0,2})?|100(?:\.0{1,2})?)$/
        if (value && !reg.test(value)) {
          callback(new Error('比例为0-100'))
        } else {
          callback()
        }
      }
      console.log(rule)
    },
    lazyLoadFn(node, resolve) {
      setTimeout(() => {
        let nodes
        let nowRenderObj = this.provinceList.find(city => city.name == node.label)
        if (nowRenderObj && nowRenderObj.children) {
          // 有子数组则不更新
        } else {
          this.areaList.forEach(x => {
            if (x.name == node.label) {
              nodes = JSON.parse(x.content).children
            }
          })
        }
        resolve(nodes);
      }, 0);
    },
    deepCludData(data) {
      data.forEach(item => {
        item.label = item.name
        item.value = item.name
        if (item.children && item.children.length) {
          this.deepCludData(item.children)
        }
        return item
      });
      return data;
    },
    confirm() {
      this.$refs.staffForm.validate(async (valid) => {
        if (valid) {
          const params = { ...this.staffForm }
          params.entryDate = this.$formart(params.entryDate, "yyyy-MM-dd hh:mm:ss");
          params.birthday = this.$formart(params.birthday, "yyyy-MM-dd hh:mm:ss");
          params.dimissionDate = this.$formart(params.dimissionDate, "yyyy-MM-dd hh:mm:ss");
          params.salaryStartDate = params.entryDate
          params.salaryEndDate = params.dimissionDate
          delete params.createTime
          delete params.updateTime
          params.address = params.address.length ? `${params.address.join(',')},${params.address_input}` : params.address_input
          params.contactAddress = params.contactAddress.length ? `${params.contactAddress.join(',')},${params.contactAddress_input}` : params.contactAddress
          params.homeAddress = params.homeAddress.length ? `${params.homeAddress.join(',')},${params.homeAddress_input}` : params.homeAddress
          if (params.situation.length) {
            if (params.situation.includes('残疾')) {
              params.disability = true
            }
            if (params.situation.includes('烈属')) {
              params.hero = true
            }
            if (params.situation.includes('孤老')) {
              params.alone = true
            }
          }else {
            params.disability = false
            params.hero = false
            params.alone = false
          }
          delete params.situation
          delete params.homeAddress_input
          delete params.address_input
          delete params.contactAddress_input
          if (this.nowRow && this.nowRow.id) {
            params.id = this.nowRow.id
          }
          this.loading = true
          const { data } = await saveStaff(params)
          this.loading = false
          if (data.code == 1) {
            this.$message.success(data.msg)
            this.isShow = false
            this.$emit('refresh')
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    close() {
      this.isShow = false
    },
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__footer {
  padding-top: 40px !important;
  border-top: none;
}

.footer {
  justify-content: center;

  /deep/ .el-button {
    width: 100px;
  }

  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}

.addStaff__dialog {
  /deep/.el-dialog__body {
    height: 500px;
    overflow-y: auto;
  }
}

.addStaff__body {
  margin-bottom: 20px;

  &__form {
    &__rows {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .rows__item {
        width: 350px !important;
      }
    }

    &__title {
      font-weight: 600;
      font-size: 16px;
      color: #666666;
      margin: 30px 0 10px 0;
      display: flex;
      align-items: center;
      line-height: 20px;

      &::before {
        content: '';
        display: inline-block;
        width: 2px;
        height: 14px;
        background: #269d7b;
        margin-right: 10px;
      }
    }

    .rows__item--tail {
      margin-bottom: 0px !important;
    }

    /deep/.el-form-item {
      margin-bottom: 15px;

      .el-form-item__label {
        line-height: 20px;
      }

      .el-form-item__content {
        line-height: 20px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salary/components/AddStaff.vue